export async function PsicoterapiaUpdate(
  psicResp,
  psicFecha,
  psicNumses,
  psicMedio,
  psicNeuronRad,
  psicNeuronEsp,
  psicMedafRad,
  psicMedafEsp,
  psicNaltRad,
  psicNaltEsp,
  psicAntRad,
  psicAntEsp,
  psicOtramedRad,
  psicOtramedEsp,
  psicSueno,
  psicFrecuenciaSueno,
  psicCalidadSueno,
  psicConsdrogprinc,
  psicConsdrogotras,
  psicActivRad,
  psicRelsocRad,
  psicTestorinRad,
  psicTipoDroga,
  psicResult,
  psicObs,
  psicEstado,
  tratamientoId,
  pacienteId,
  psicoterapiaId
) {
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-psic-${psicNumses}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-psic-${psicNumses}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      psicResp: psicResp,
      metaFecha: psicFecha,
      metaPaciente: pacienteId,
      psicNumses: psicNumses,
      psicMedio: psicMedio,
      psicNeuronRad: psicNeuronRad,
      psicNeuronEsp: psicNeuronEsp,
      psicMedafRad: psicMedafRad,
      psicMedafEsp: psicMedafEsp,
      psicNaltRad: psicNaltRad,
      psicNaltEsp: psicNaltEsp,
      psicAntRad: psicAntRad,
      psicAntEsp: psicAntEsp,
      psicOtramedRad: psicOtramedRad,
      psicOtramedEsp: psicOtramedEsp,
      psicSueno: psicSueno,
      psicFrecuenciaSueno: psicFrecuenciaSueno,
      psicCalidadSueno: psicCalidadSueno,
      psicConsdrogprinc: psicConsdrogprinc,
      psicConsdrogotras: psicConsdrogotras,
      psicActivRad: psicActivRad,
      psicRelsocRad: psicRelsocRad,
      psicTestorinRad: psicTestorinRad,
      psicObs: psicObs,
      psicTipoDroga: psicTipoDroga,
      psicResult: psicResult,
      psicEstado: psicEstado,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/psicoterapia/${psicoterapiaId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}

export async function TratamientoEstadoUpdate(estado, tratamientoId) {
  console.log(estado, tratamientoId);
  const formData = {
      meta: {
          estado: estado,
      }
      
  };

const authToken = sessionStorage.getItem( 'token' );

      try {
          const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/tratamiento/${tratamientoId}`, {
              method: 'POST',
              headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${ authToken }`,
              
              },
              body: JSON.stringify(formData),
          } );
          const values = await response.json();
          console.log(values);
          return values;
      } catch (error) {
          console.error(error);
      }

}